// src/pages/taxonomy/TaxonomyPage/TaxonomyPage.jsx
import React from 'react';
import { Link } from 'react-router-dom';

const BASE = '/app/sales/bagspa/taxonomy';

export default function TaxonomyPage() {
  return (
    <div>
      <h2 className="mb-3">Taxonomy</h2>
      <p className="text-muted">Manage Brands, Categories, Colours, Materials, Sizes, and Order Categories.</p>
      <div
        className="grid gap-3"
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(240px,1fr))',
        }}
      >
        <Link className="card p-3 border" to={`${BASE}/brands`}>
          <div className="font-weight-bold mb-1">Brands</div>
          <div className="text-muted small">Create / edit brand names (unique).</div>
        </Link>

        <Link className="card p-3 border" to={`${BASE}/categories`}>
          <div className="font-weight-bold mb-1">Categories</div>
          <div className="text-muted small">Create / edit product categories (unique).</div>
        </Link>

        <Link className="card p-3 border" to={`${BASE}/colours`}>
          <div className="font-weight-bold mb-1">Colours</div>
          <div className="text-muted small">Create / edit colours (unique).</div>
        </Link>

        <Link className="card p-3 border" to={`${BASE}/materials`}>
          <div className="font-weight-bold mb-1">Materials</div>
          <div className="text-muted small">Create / edit materials (with codes).</div>
        </Link>

        <Link className="card p-3 border" to={`${BASE}/sizes`}>
          <div className="font-weight-bold mb-1">Sizes</div>
          <div className="text-muted small">Create / edit product sizes (with codes).</div>
        </Link>

        <Link className="card p-3 border" to={`${BASE}/order_categories`}>
          <div className="font-weight-bold mb-1">Order Categories</div>
          <div className="text-muted small">
            Define categories for Orders (with code & active flag).
          </div>
        </Link>
      </div>
    </div>
  );
}
